
// Get Products
export const FETCH_PRODUCTS_BEGIN = 'FETCH_PRODUCTS_BEGIN'
export const RECEIVE_PRODUCTS = 'RECEIVE_PRODUCTS'
export const FETCH_SINGLE_PRODUCT = 'FETCH_SINGLE_PRODUCT'
export const RECEIVE_POPULAR_PRODUCTS = 'RECEIVE_POPULAR_PRODUCTS'

// Get Customer
export const FETCH_SINGLE_CUSTOMER = 'FETCH_SINGLE_CUSTOMER'

// FILTERS
export const FILTER_BRAND = 'FILTER_BRAND'
export const FILTER_COLOR = 'FILTER_COLOR'
export const FILTER_PRICE = 'FILTER_PRICE'
export const SORT_BY = 'SORT_BY'

export const CHANGE_CURRENCY = 'CHANGE_CURRENCY'


// Cart
export const ADD_TO_CART = 'ADD_TO_CART'
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART'
export const INCREMENT_QTY = 'INCREMENT_QTY'
export const DECREMENT_QTY = 'DECREMENT_QTY'
export const UPDATE_CART = 'UPDATE_CART'
export const CLEAR_CART = 'CLEAR_CART'



// WishList
export const ADD_TO_WISHLIST = 'ADD_TO_WISHLIST'
export const REMOVE_FROM_WISHLIST = 'REMOVE_FROM_WISHLIST'


// Compare
export const ADD_TO_COMPARE = 'ADD_TO_COMPARE'
export const REMOVE_FROM_COMPARE = 'REMOVE_FROM_COMPARE'



// CheckOut Process
export const CHECKOUT_REQUEST = 'CHECKOUT_REQUEST'
export const CHECKOUT_SUCCESS = 'CHECKOUT_SUCCESS'
export const CHECKOUT_FAILURE = 'CHECKOUT_FAILURE'


// CATEGORY
export const UPDATE_CATEGORY_AND_PRODUCTS = 'UPDATE_CATEGORY_AND_PRODUCTS';
export const UPDATE_CATEGORY_PRODUCTS = 'UPDATE_CATEGORY_PRODUCTS';
export const UPDATE_CATEGORIES_LIST = 'UPDATE_CATEGORIES_LIST';

export const UPDATE_ORDER_NOTES = 'UPDATE_ORDER_NOTES';
export const UPDATE_SHOW_TEXTBOX = 'UPDATE_SHOW_TEXTBOX';
export const UPDATE_SHOW_RETURN_ADDRESS = 'UPDATE_SHOW_RETURN_ADDRESS';
export const UPDATE_RETURN_ADDRESS = 'UPDATE_RETURN_ADDRESS';
